const STANDARDS = [
  {
    tag: 'SECURE',
    label: '100% Secure Registry',
    icon: (
      <>
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
  },
  {
    tag: 'AUTHENTIC',
    label: 'Authentic Vedic Solutions',
    icon: (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
  },
  {
    tag: 'PRECISION',
    label: 'Clinical Remedy Protocol',
    icon: <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />,
  },
  {
    tag: 'GLOBAL',
    label: 'Global Node Availability',
    icon: (
      <>
        <path d="M11 2v2" />
        <path d="M5 2v2" />
        <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" />
        <path d="M8 15a6 6 0 0 0 12 0v-3" />
        <circle cx="20" cy="10" r="2" />
      </>
    ),
  },
]

export default function StandardsSection() {
  return (
    <section className="py-24 bg-white/30 border-t border-border/40">
      <div className="container px-6 mx-auto">
        <div className="max-w-3xl w-full mx-auto text-center mb-16">
          <span className="text-secondary text-[10px] tracking-[0.3em] uppercase mb-4 block font-normal">Consultation Quality</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-cinzel text-primary leading-tight mb-6 font-normal uppercase">
            Professional Vedic <span className="text-secondary">Standards</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {STANDARDS.map((item) => (
            <div key={item.tag} className="group p-8 rounded-[2rem] bg-white border border-border/40 transition-all hover:border-[#991b1b] hover:bg-[#991b1b] text-center space-y-4">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary/5 border border-border/50 flex items-center justify-center text-secondary transition-all group-hover:bg-white group-hover:text-[#991b1b]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  {item.icon}
                </svg>
              </div>
              <div className="space-y-1">
                <p className="text-[9px] font-mono font-bold text-secondary tracking-[0.4em] uppercase group-hover:text-white">{item.tag}</p>
                <p className="text-sm font-bold text-primary tracking-wide group-hover:text-white">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
